import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { formatLicenseContent } from '../../../../helpers/license'
import Confirmation from '../../Modal/Confirmation'

class CollaborativeIndexation extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        accept: PropTypes.func.isRequired,
        refuse: PropTypes.func.isRequired,
        license: PropTypes.string.isRequired,
    }

    render()
    {
        const { t, accept, refuse, license } = this.props

        return <Confirmation
            title={t('visualizer:disclaimers.collaborativeIndexation.title')}
            content={formatLicenseContent(license)}
            confirm={accept}
            confirmLabel={t('visualizer:license.buttons.accept')}
            cancel={refuse}
            cancelLabel={t('visualizer:license.buttons.refuse')}
        />
    }
}

export default withTranslation()(CollaborativeIndexation)
